import styled from 'styles/styled';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ContentTop = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContentBottom = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  overflow: hidden;
`;

export const RowTop = styled.div`
  padding: 24px 15px 20px 15px;
`;

export const RowContent = styled.div`
  margin-bottom: 20px;
`;

export const RowBelt = styled.div`
  margin-bottom: 15px;
  &.lastRowBelt {
    margin-bottom: 20px;
  }
`;

export const Title = styled.h3`
  text-align: center;
  font-size: 18px;
  line-height: 20px;
  font-weight: 700;
  color: #EFEFEF;
`;

export const LineText = styled.h4`
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  color: #EFEFEF;
  background-color: #292B2E;
  border: 1px solid rgba(255, 255, 255, 0.04);
  width: 100%;
  min-height: 32px;
  padding: 6px 12px;
  border-radius: 8px;
  line-height: 20px;
  font-variant-numeric: tabular-nums;
  &.finishedColor {
    background-color: #52D381;
    color: #0A0A0A;
    border-color: transparent;
  }
`;

export const TitleSecond = styled.h5`
  text-align: center;
  font-size: 11px;
  line-height: 14px;
  color: #7A7E8C;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 6px;
`;
